import React from "react";
import BaseTimeSeriesWidgetRO from "../base-widgets/BaseTimeSeriesWidgetRO";
import { AnalyticsWidget as AnalyticsWidgetComponent } from "../../../components/widgets";

const AnalyticsWidget = props => {
  return (
    <BaseTimeSeriesWidgetRO {...props}>
      {baseProps => {
        return (
          <AnalyticsWidgetComponent {...baseProps} data={baseProps.streams} />
        );
      }}
    </BaseTimeSeriesWidgetRO>
  );
};

export default AnalyticsWidget;
